import Vue from 'vue';

export default {
    loadAllProjectsSuccess(state, payload) {
        Vue.set(state.projects, 'data', payload);
        Vue.set(state.projects, 'dataIsLoading', false);
    },
    loadAllProjectsError(state) {
        Vue.set(state.projects, 'dataIsLoading', false);
        Vue.set(state.projects, 'hasError', true);
    },

};
